export type ReportEntityType = 'Client' | 'Plate' | 'Ticket';

export type FilterOperator =
  | 'Equals'
  | 'NotEquals'
  | 'Contains'
  | 'GreaterThan'
  | 'LessThan'
  | 'IsEmpty'
  | 'IsNotEmpty';

export interface ReportFilter {
  id: string; // For React key
  field: string;
  operator: FilterOperator;
  value: string;
}

export interface DropdownOption {
  value: string;
  label: string;
}

export interface ReportFieldMetadata {
  fieldName: string;
  displayName: string;
  valueType: 'String' | 'Number' | 'Boolean' | 'Date' | 'Dropdown';
  dropdownOptions?: DropdownOption[];
}

export interface ReportBuilderRequest {
  entityType: number; // 0 = Client, 1 = Plate, 2 = Ticket
  filters: Array<{
    field: string;
    operator: number; // FilterOperator enum value
    value: string;
  }>;
  selectedFields: string[];
}

export interface ReportPreview {
  headers: string[];
  rows: string[][];
  totalCount: number;
}

// Helper to convert FilterOperator string to number
export const filterOperatorToNumber = (operator: FilterOperator): number => {
  const mapping: Record<FilterOperator, number> = {
    Equals: 0,
    NotEquals: 1,
    Contains: 2,
    GreaterThan: 3,
    LessThan: 4,
    IsEmpty: 5,
    IsNotEmpty: 6
  };
  return mapping[operator];
};

// Helper to convert ReportEntityType string to number
export const entityTypeToNumber = (entityType: ReportEntityType): number => {
  const mapping: Record<ReportEntityType, number> = {
    Client: 0,
    Plate: 1,
    Ticket: 2
  };
  return mapping[entityType];
};

// Get available operators based on field value type
export const getOperatorsForValueType = (
  valueType: ReportFieldMetadata['valueType']
): FilterOperator[] => {
  switch (valueType) {
    case 'String':
      return ['Equals', 'NotEquals', 'Contains', 'IsEmpty', 'IsNotEmpty'];
    case 'Number':
      return ['Equals', 'NotEquals', 'GreaterThan', 'LessThan'];
    case 'Boolean':
      return ['Equals', 'NotEquals'];
    case 'Date':
      return ['Equals', 'NotEquals', 'GreaterThan', 'LessThan', 'IsEmpty', 'IsNotEmpty'];
    case 'Dropdown':
      return ['Equals', 'NotEquals'];
    default:
      return ['Equals', 'NotEquals'];
  }
};
